/**
 * @fileoverview List skeleton (plan Parte 6.2): project filter + N card skeletons
 * mixing layouts to reflect the three task types.
 */

import { Skeleton, Stack } from '@mantine/core'
import { LIST_SKELETON_COUNT, SKELETON } from '../../constants'
import { StudentTaskCardSkeleton } from './StudentTaskCardSkeleton'

/** Alternates column count / due date to evoke the real mixed list. */
const variantFor = (index: number) => ({
  twoColumns: index % 3 !== 2,
  withDueDate: index % 3 === 0,
})

export function StudentTasksListSkeleton() {
  return (
    <Stack spacing="md">
      <Skeleton height={SKELETON.filter.height} width={SKELETON.filter.width} radius="sm" />
      <Stack spacing="md">
        {Array.from({ length: LIST_SKELETON_COUNT }, (_, index) => (
          <StudentTaskCardSkeleton key={index} {...variantFor(index)} />
        ))}
      </Stack>
    </Stack>
  )
}
